import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import './BookingBarButtons.scss';

const BookingBarButtons = ({
  disabled,
  onClick,
  isBookable,
  moveIn = '',
  moveOut = ''
}) => {
  const handleOnClick = (...args) => {
    onClick(...args);
  };

  const showDates = moveIn || moveOut;

  if (!isBookable) {
    return null;
  }

  return (
    <div className="booking-bar-buttons">
      <Button
        data-test="bookingBarButton"
        className="booking-bar-buttons__cta"
        size="large"
        disabled={disabled}
        onClick={handleOnClick}
      >
        {showDates
          ? `${trans('property_show.book_now_card.request_continue')} >>`
          : trans('property_show.book_now_card.check_availability')}
      </Button>
    </div>
  );
};

BookingBarButtons.propTypes = {
  disabled: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isBookable: PropTypes.bool.isRequired,
  moveIn: PropTypes.string,
  moveOut: PropTypes.string
};

export default BookingBarButtons;
